import { Box, Paper, Tab, Tabs } from "@mui/material";
import React from "react";
import { StoreObjectStore } from "../../ObjectStore/StoreObjectStore";
import CategoryTitle from "../atoms/CategoryTitle";
import StudioPriceList from "./StudioPriceList";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`studio-price-tabpanel-${index}`}
            aria-labelledby={`studio-price-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `studio-price-tab-${index}`,
        'aria-controls': `studio-price-tabpanel-${index}`,
    };
}

const StoreDetailStudioPrice: React.FC = () => {
    const { storeObjectState } = React.useContext(StoreObjectStore)
    const [selectedTab, setSelectedTab] = React.useState<number>(0)

    // const [studioId, setStudioId] = React.useState<number>()

    // const reloadStudioList = React.useCallback(() => {
    //     if( storeObjectState.storeData?.str_id ) {
    //         getStudioList(storeObjectState.storeData?.str_id, true).then((studioDataList: StudioData[]) => {
    //             storeObjectDispatch({type: 'setStudioList', payload: studioDataList})
    //         })
    //     }
    // },[storeObjectState.storeData?.str_id])

    return (
        <Paper sx={{ mt: 2, pb: 2 }}>
            <CategoryTitle
                text="スタジオ料金設定"
            />
            <Box>
                <Box
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider'
                    }}
                >
                    <Tabs
                        value={selectedTab}
                        onChange={(event, value) => {
                            setSelectedTab(value)
                        }}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                    >
                        {storeObjectState.studioList?.map((studioData, index) => (
                            <Tab
                                label={studioData.std_name}
                                key={studioData.std_id}
                                sx={{
                                    textTransform: "none"
                                }}
                                {...a11yProps(index)}
                            />
                        ))}
                    </Tabs>
                </Box>
                <Box>
                    {storeObjectState.studioList?.map((studioData, index) => (
                        <TabPanel
                            value={selectedTab}
                            index={index}
                            key={index}
                        >
                            {studioData.str_id && studioData.std_id &&
                                <StudioPriceList
                                    str_id={studioData.str_id}
                                    std_id={studioData.std_id}
                                />
                            }
                        </TabPanel>
                    ))}
                </Box>

            </Box>
        </Paper>
    );
}

export default StoreDetailStudioPrice